import { useCallback, useRef, useState, useEffect } from 'react';

export const useClipboardCopy = (code: string) => {
  const [copyActive, setCopyActive] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleCopyCode = useCallback(() => {
    if (!code) return;

    navigator.clipboard.writeText(code);

    if (!copyActive) {
      setCopyActive(true);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setCopyActive(false);
        timeoutRef.current = null;
      }, 1000);
    }
  }, [code, copyActive]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { handleCopyCode, copyActive };
};
